<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { type ErrorType } from '@/types/Errors'

const value = ref()

const emit = defineEmits(['update:modelValue'])

interface Props {
    errors: ErrorType
    data?: string
    label?: string
    maxLength?: number
    field: string
    required?: boolean
    placeholder?: string
    containerClasses?: string
}

const props = withDefaults(defineProps<Props>(), {
    //
})

const selectedColor = ref('#000000')

const updateColor = (event: any) => {
    selectedColor.value = event.target.value
}

const inputVal = computed({
    get: () => {
        return value.value
    },
    set: (val) => {
        value.value = val
        emit('update:modelValue', val)
    }
})

onMounted(() => {
    if (props.data) {
        value.value = props.data
        selectedColor.value = props.data
    }
})
</script>
<template>
    <div class="form-group" :class="containerClasses">
        <label v-if="!!label" class="text-xs"
            >{{ label }}<span v-if="required" class="text-danger pl-1">*</span></label
        >
        <div
            :class="
                !!field && errors.hasOwnProperty(field) ? 'border-danger' : 'border-line-strong'
            "
            class="form-control w-full px-3 py-[0.41rem] text-sm leading-6 font-normal text-fg-muted bg-surface bg-clip-padding border border-solid rounded transition ease-in-out m-0 outline-0 focus:text-fg-muted focus:bg-surface focus:ring focus:ring-primary focus:ring-opacity-30 border-line-strong flex"
        >
            <input
                class="mr-1 bg-transparent cursor-pointer"
                type="color"
                v-model="inputVal"
                @input="updateColor"
            />
            <span class="w-full">{{ selectedColor }}</span>
        </div>
        <i
            class="text-danger text-xs"
            v-if="
                !!field &&
                errors.hasOwnProperty(field) &&
                !!errors[field] &&
                errors[field].length > 0
            "
            >{{ errors[field][0] }}</i
        >
    </div>
</template>
<style scoped></style>
